module.exports = __webpack_public_path__ + "static/media/Bellanaisa.1249a9ae.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Bellanaisa.eot
// module id = 2257
// module chunks = 43